import { createRouter, createWebHistory } from '@ionic/vue-router';
import Login from '../pages/Login.vue'
import Home from '../pages/Home.vue'
import Settings from '../pages/Settings.vue'
import Visits from '../pages/Visits.vue'
import NewVisit from '../pages/NewVisit.vue'
import Customers from '../pages/Customers.vue'
import Products from '../pages/Products.vue'
import Inventory from '../pages/Inventory.vue'
import Scan from '../pages/Scan.vue'
import store from '../store';

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/visits',
    name: 'Visits',
    component: Visits
  },
  {
    path: '/newvisit',
    name: 'NewVisit',
    component: NewVisit
  },
  {
    path: '/customers',
    name: 'Customers',
    component: Customers
  },
  {
    path: '/products/:pitem_id',
    name: 'Products',
    component: Products
  },
  {
    path: '/inventory',
    name: 'Inventory',
    component: Inventory
  },
  {
    path: '/scan/:open_scan',
    name: 'Scan',
    component: Scan
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  mode: 'hash'
})

router.beforeEach(function(to, _, next) {
  store.dispatch('tryLogin');
  console.log('is authenticated: '+store.getters.isAuthenticated);
  console.log(to);
  console.log("next:"+next);
  if (store.getters.isAuthenticated) {
    if(to.name=='Login'){
      next('/home');
    } else {
      next();
    }
  } else {
    if(to.name=='Login'){
      next();
    } else {
      next('/login');
    }
  }
});

export default router
